/* Presentation-only: move existing nodes without editing policy text or links. */
(() => {
  const root = document.querySelector('.it-policy');
  if (!root) return;
  const heading = [...root.querySelectorAll('.shopify-policy__body h2')]
    .find(h => h.textContent.trim() === 'Store technology and privacy');
  if (!heading || root.querySelector('.it-shopify-info')) return;
  const panel = document.createElement('section');
  panel.className = 'it-shopify-info';
  panel.setAttribute('aria-label', 'Shopify services and privacy information');
  const label = document.createElement('span');
  label.className = 'it-shopify-label';
  label.textContent = 'SHOPIFY SERVICES & PRIVACY';
  panel.append(label);
  heading.before(panel);
  // Include every existing following sibling, preserving wording, order and links.
  let node = heading;
  while (node) {
    const next = node.nextSibling;
    panel.append(node);
    node = next;
  }
})();
